export const CREDIENTIALS = [
    {
        email: "instructor.care.library@gmail.com",
        password: "Instructor@123",
        role: "instructor",
    },
    {
        email: "client.care.library@gmail.com",
        password: "Client@123",
        role: "client",
    },
    {
        email: "coordinator.care.library@gmail.com",
        password: "Coordinator@123",
        role: "coordinator",
    },
    {
        email: "carer.care.library@gmail.com",
        password: "Carer@123",
        role: "carer",
    },
    {
        email: "admin.care.library@gmail.com",
        password: "Admin@123",
        role: "admin",
    },
    {
        email: "super-admin.care.library@gmail.com",
        password: "SuperAdmin@123",
        role: "superAdmin",
    }
]